import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { QuotationData } from '../../models/quotations/Quotations';

export const QUOTES_URL = '/api/v1/offers';

const useQuotationsSWR = () => {
    const fetch = (query): Promise<QuotationData[]> => {
        return httpApi
            .get<{ offers: QuotationData[] }>(query)
            .then((res) => {
                return res.getData().offers;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(QUOTES_URL, fetch, {
        dedupingInterval: 600000, // 10min
        errorRetryCount: 3,
    });

    return {
        quotes: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useQuotationsSWR;
